import React from 'react';
import RecentCases from './RecentCases';

function FactFinderHome({ onSelectMode, onOpenCase }) {
  return (
    <div className="fact-finder-page">
      <div className="ff-container ff-home">
        <div className="ff-home-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <img src="/stewie_front.png" alt="Stewie" data-testid="stewie-logo" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', objectPosition: 'center 25%', border: '2px solid #334155' }} />
            <div className="ff-badge">Documentation Tool</div>
          </div>
          <h1>Fact Finder</h1>
          <p className="ff-subtitle">
            Document what happened and prepare for next steps.
          </p>
        </div>

        <div className="ff-mode-grid">
          <button
            className="ff-mode-card ff-mode-primary"
            onClick={() => onSelectMode('investigation')}
            data-testid="investigation-mode-btn"
          >
            <div className="ff-mode-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </div>
            <div className="ff-mode-content">
              <h2>Investigation Mode</h2>
              <p>Prepare for a meeting, questioning, or written statement request.</p>
              <span className="ff-mode-tag">Recommended</span>
            </div>
          </button>

          <button
            className="ff-mode-card"
            onClick={() => onSelectMode('quick-log')}
            data-testid="quick-log-btn"
          >
            <div className="ff-mode-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </div>
            <div className="ff-mode-content">
              <h2>Quick Log</h2>
              <p>Capture what happened fast before details get lost.</p>
              <span className="ff-mode-tag ff-tag-fast">Under 60 Seconds</span>
            </div>
          </button>

          <button
            className="ff-mode-card"
            onClick={() => onSelectMode('full-record')}
            data-testid="full-record-btn"
          >
            <div className="ff-mode-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
            </div>
            <div className="ff-mode-content">
              <h2>Build Full Record</h2>
              <p>Create a full summary, timeline, and statement draft.</p>
              <span className="ff-mode-tag ff-tag-complete">Comprehensive</span>
            </div>
          </button>

          <button
            className="ff-mode-card"
            onClick={() => onSelectMode('grievance-prep')}
            data-testid="grievance-prep-btn"
          >
            <div className="ff-mode-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <div className="ff-mode-content">
              <h2>Grievance Prep</h2>
              <p>Build a formal grievance with contract references and supporting facts.</p>
              <span className="ff-mode-tag" style={{ background: 'rgba(168,85,247,0.15)', color: '#c084fc' }}>Union Rights</span>
            </div>
          </button>
        </div>

        <RecentCases onOpenCase={onOpenCase} />

        <div className="ff-info-box">
          <h3>Why this matters</h3>
          <ul>
            <li><span className="check">&#10003;</span> Stay factual</li>
            <li><span className="check">&#10003;</span> Avoid guessing or speculating</li>
            <li><span className="check">&#10003;</span> Build a clean timeline</li>
            <li><span className="check">&#10003;</span> Walk into meetings more prepared</li>
          </ul>
        </div>

        <div className="ff-taglines">
          <p><strong>Called into the office?</strong> Open Investigation Mode first.</p>
          <p><strong>Before you write a statement</strong>, run it through Fact Finder.</p>
          <p><strong>Log it now</strong> before details get lost.</p>
        </div>
      </div>
    </div>
  );
}

export default FactFinderHome;
